import React from 'react';
import { fetchMonthlyTransactionReports } from 'apiRequest/transaction-report';
import TransactionReportPageContainer from 'components/TransactionReportPageContainer';

export default function TransactionReportMontly() {
  return (
    <TransactionReportPageContainer fetch={fetchMonthlyTransactionReports} />
  );
};
